export default __webpack_public_path__ + "static/media/project10.043ac421.webp";